'use strict';

$(window).load(function () {
    $('[js-header-search-button]').on('click', function () {
       var searchStr = $(this).siblings('[js-header-search-input]').val();
       if(searchStr != ''){
           window.location.href = '/search/' + searchStr + '/';
       }
    });
    $('[js-header-search-input]').keyup(function(event){
        if(event.keyCode == 13) {
            var searchStr = $('[js-header-search-input]').val();
            if (searchStr != '') {
                window.location.href = '/search/' + searchStr + '/';
            }
        }
    });
});